package com.yendo.mx.utils

import dev.gitlive.firebase.storage.Data
import org.khronos.webgl.Uint8Array
import org.khronos.webgl.set

actual fun ByteArray.toStorageData(): Data {
    val uint8Array = Uint8Array(this.size)
    for (i in indices) {
        uint8Array[i] = this[i]
    }
    return Data(uint8Array)
}
